import { brandRecommendForm } from "./brand-recommend-form";

type BrandRecommendHandlerLike = {
    handleRecommendClick(event: MouseEvent, el: HTMLElement): Promise<void>;
};

export class BrandRecommendListener {
    public handler: BrandRecommendHandlerLike;

    public _registered: boolean;

    public constructor(deps: { handler: BrandRecommendHandlerLike }) {
        this.handler = deps.handler;
        this._registered = false;
    }

    public register(): void {
        if (this._registered) return;
        this._registered = true;

        document.addEventListener(
            "click",
            (e) => {
                if (!(e instanceof MouseEvent)) return;
                const event = e;
                const target = brandRecommendForm.getEventTarget(event, Element);
                if (!target) return;

                const crownEl = brandRecommendForm.getClosestRecommendButton(target);
                if (crownEl instanceof HTMLElement) {
                    const card = brandRecommendForm.getBrandCard(crownEl);
                    const canRecommend =
                        crownEl.dataset?.canRecommend === "1" ||
                        (card instanceof HTMLElement && card.dataset?.canRecommend === "1") ||
                        !!brandRecommendForm.getRecommendCapabilityHost(crownEl);
                    if (canRecommend) {
                        void this.handler.handleRecommendClick(event, crownEl);
                        return;
                    }
                }
            },
            { capture: true },
        );
    }
}
